import './EditorCommon.css';

export type AlignmentType = 'align_left' | 'align_center' | 'align_right';
export const BLOCK_STYLE_ALIGN_LEFT = 'align_left';
export const BLOCK_STYLE_ALIGN_CENTER = 'align_center';
export const BLOCK_STYLE_ALIGN_RIGHT = 'align_right';
